
import { Inject, mixins, Options, Prop } from 'vue-property-decorator'

import ContentCardMixin from '../../mixins/ContentCardMixin'
import GalleryFull from '../icons/GalleryFull.vue'
import Play from '../icons/Play.vue'
import NavLink from '../NavLink.vue'
import Tag from '../Tag.vue'
import ContentImage from './ContentImage.vue'
import MinuteByMinuteLead from './MinuteByMinuteLead.vue'

@Options({
  name: 'ContentCard',
  components: {
    ContentImage,
    MinuteByMinuteLead,
    NavLink,
    Play,
    GalleryFull,
    Tag,
  }
})
export default class ContentCard extends mixins(ContentCardMixin) {
  @Inject({ from: 'target', default: '' })
  readonly target!: string

  @Inject({ from: 'utmMedium', default: null })
  readonly utmMedium!: string | null

  @Inject({ from: 'utmSource', default: null })
  readonly utmSource!: string | null

  @Inject({ from: 'utmCampaign', default: null })
  readonly utmCampaign!: string | null

  @Prop({ type: Boolean, default: true })
  readonly navigation!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  readonly isLcp!: boolean

  get _url () {
    if (this.utmCampaign && this.utmSource && this.utmMedium) {
      return `${this.url}?utm-source=${this.utmSource}&utm-campaign=${this.utmCampaign}&utm-medium=${this.utmMedium}`
    } else {
      return this.url
    }
  }
}
